import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
export default function () {
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    items.add('awardedBestAnswer', {
      name: 'awardedBestAnswer',
      icon: 'fas fa-check',
      label: app.translator.trans('fof-best-answer.forum.notification.preferences.awarded_best_answer')
    });
    items.add('bestAnswerInDiscussion', {
      name: 'bestAnswerInDiscussion',
      icon: 'fas fa-check',
      label: app.translator.trans('fof-best-answer.forum.notification.preferences.best_answer_in_discussion')
    });
    items.add('selectBestAnswer', {
      name: 'selectBestAnswer',
      icon: 'fas fa-stopwatch',
      label: app.translator.trans('fof-best-answer.forum.notification.preferences.select_best_answer')
    });
  });
}